/**
 * Copyright (C) 2021 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Box } from '@mui/material';
import React from 'react';
import Scrollbars from './layout/Scrollbars';

const CustomListBox = (props: JSX.IntrinsicAttributes) => {
  return (
    <Scrollbars autoHeight autoHeightMin="30px" autoHeightMax="300px">
      <Box sx={{ ul: { maxHeight: '300px', overflow: 'visible' , fontSize: '14px'} }}>
        <ul {...props} />
      </Box>
    </Scrollbars>
  );
};

export default CustomListBox;
